import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const getLessonDetailsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "getLessonDetails",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
        lessonDetails: evt.data
      }))
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("getLessonDetails", {
            messageData: ["get the selected lesson details"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
